import { render, staticRenderFns } from "./Efficiency.vue?vue&type=template&id=f799cc1e"
import script from "./Efficiency.vue?vue&type=script&lang=js"
export * from "./Efficiency.vue?vue&type=script&lang=js"
import style0 from "./Efficiency.vue?vue&type=style&index=0&id=f799cc1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports